import React from 'react';
import CAppTitle from '../../../app/components/CAppTitle';
import VNewsArticleList from '../views/VNewsArticleList';

const PNewsArticles = () => {
	return (
		<>
			<CAppTitle title="Sienna news" />
			<VNewsArticleList />
		</>
	);
};

export default PNewsArticles;
